<template>
  <div>
    <LoginMain />
  </div>
</template>

<script>
import LoginMain from '@/components/Settings/LoginMain'

export default {
  components: {
    LoginMain
  },
  created: async function () {
    await this.$store.dispatch('user/fetchUser')
    this.$store.dispatch('user/resetAttrs')
  }
}
</script>
